import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

export const LayoutRoot = styled(Stack)({
    minHeight: "100vh",
});

export const LayoutBody = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        p: { md: 7, xs: 4 },
        pb: { xs: "80px", md: 7 },
        flex: 1,
    }),
);

export const ContentWrapper = styled(Stack)({
    width: "100%",
    maxWidth: "962px",
    marginLeft: "auto",
    marginRight: "auto",
});
